import React, { useState } from 'react';
//import { withLoadPanel } from '../../../utils/withLoadPanel';
import { TaskFormDetails } from './TaskFormDetails';
import { ToolbarForm } from '../../utils/toolbar-form/ToolbarForm';
import { WorkTask } from '../../../types/task';
import './TaskForm.scss';
//const TaskFormWithLoadPanel = withLoadPanel(TaskFormDetails);

export const TaskForm = ({ workTask } : { workTask: WorkTask }) => {
  const [ data ] = useState<WorkTask>(workTask);
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const noop = () => {};

  return (
    <div className='task-form'>
      <ToolbarForm titel='Opdracht gegevens' editing={false} toggleEditing={noop} onCancelClick={noop} onSaveClick={noop} />
      <TaskFormDetails editing={false} data={data} subjectField={false} onDataChanged={noop} />
    </div>
  );
};
